import { LastMessageText } from '@halo/ui-chat-react';
import { Box, Text } from '@chakra-ui/react';
import { useMsgMediaTitle } from '../msg-media-call';
import type { MsgMediaCallRejectedContentProps } from './msg-media-call-rejected-content';
import { MsgMediaCallRejectedContent } from './msg-media-call-rejected-content';

export interface MsgMediaCallRejectedPreviewProps extends MsgMediaCallRejectedContentProps {}

export const MsgMediaCallRejectedPreview = memo(function MsgMediaCallRejectedPreview({
  message,
}: MsgMediaCallRejectedPreviewProps) {
  const { type } = message.payload;

  const { title } = useMsgMediaTitle({ type });

  return (
    <LastMessageText>
      <Text as="span" color="fg.error" flexShrink={0}>
        {title}
      </Text>
      <Box as="span" truncate minW={0} flex={1}>
        <MsgMediaCallRejectedContent message={message} />
      </Box>
    </LastMessageText>
  );
});
